// Barra de vidrio: pastilla verde que sigue al mouse entre los links (se estira al viajar, como la barra de SULT)
// y cambio de tono del vidrio según lo que haya debajo (sección oscura o clara). 2026-10-06.
(function () {
  const bar = document.querySelector('.topbar'); if (!bar) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- pastilla que se desliza: una por cada grupo (links del menú / cuenta) ----
  function glider(group, items, rest) {
    if (!group || !items.length) return;
    const g = document.createElement('span'); g.className = 'glide'; g.setAttribute('aria-hidden', 'true');
    group.prepend(g);
    let cur = null, t = 0;
    const home = rest != null ? items[rest] : null;     // si el grupo tiene un botón principal, la pastilla descansa ahí
    const box = el => { const r = el.getBoundingClientRect(), p = group.getBoundingClientRect(); return { x: r.left - p.left, w: r.width }; };
    const place = (x, w) => { g.style.transform = `translateX(${x}px)`; g.style.width = w + 'px'; };
    function go(el) {
      clearTimeout(t);
      items.forEach(i => i.classList.toggle('lit', i === el));
      const b = box(el);
      if (!cur || reduce) { g.classList.add('stretch'); place(b.x, b.w); g.offsetWidth; g.classList.remove('stretch'); }
      else if (cur !== el) {               // primero se estira hasta cubrir los dos links, después se acomoda en el nuevo
        const a = box(cur), x = Math.min(a.x, b.x), w = Math.max(a.x + a.w, b.x + b.w) - x;
        g.classList.add('stretch'); place(x, w);
        t = setTimeout(() => { g.classList.remove('stretch'); place(b.x, b.w); }, 140);
      }
      g.classList.add('on'); cur = el;
    }
    function leave() {
      clearTimeout(t);
      if (home) { go(home); return; }
      g.classList.remove('on'); items.forEach(i => i.classList.remove('lit')); cur = null;
    }
    items.forEach(el => { el.addEventListener('pointerenter', e => { if (e.pointerType !== 'touch') go(el); }); el.addEventListener('focus', () => go(el)); el.addEventListener('blur', leave); });
    group.addEventListener('pointerleave', leave);
    if (home) { const settle = () => { cur = null; go(home); }; settle(); addEventListener('resize', settle); document.fonts && document.fonts.ready.then(settle); }
  }
  // grupos de botones de vidrio fuera de la barra (ej. los del hero): <div class="glass-group" data-rest="0">
  document.querySelectorAll('.glass-group').forEach(gr => glider(gr, [...gr.querySelectorAll('a,button')], gr.dataset.rest != null ? +gr.dataset.rest : null));
  const nav = bar.querySelector('.nav');
  glider(nav, nav ? [...nav.querySelectorAll('a')] : []);
  const acts = bar.querySelector('.pillacts');
  glider(acts, acts ? [...acts.querySelectorAll('.acct')] : []);

  // ---- vidrio oscuro o claro según el fondo de lo que pasa por debajo ----
  const lum = c => { const m = c.match(/\d+(\.\d+)?/g); if (!m) return null; const [r, g, b, a = 1] = m.map(Number); if (a < .5) return null; return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255; };
  function bgUnder(x, y) {
    // todas las capas en ese punto, de arriba hacia abajo (los fondos de los heroes suelen ser capas absolutas detrás del texto)
    for (const el of document.elementsFromPoint(x, y)) {
      if (bar.contains(el) || el.closest('.menu,.ck,.ck-ov,#draft,.draft')) continue;
      const marcado = el.closest('[data-tono]');                              // secciones con foto que avisan su tono (ej. el hero con velo oscuro)
      if (marcado) return marcado.dataset.tono === 'oscuro' ? 0.1 : 0.9;
      if (el.tagName === 'IMG' || el.tagName === 'VIDEO') return 0.6;          // fotos: tratarlas como claras (las del sitio son de fondo blanco)
      const cs = getComputedStyle(el);
      const l = lum(cs.backgroundColor); if (l !== null) return l;
      const gr = cs.backgroundImage.match(/rgba?\([^)]+\)/);                   // degradés: alcanza con su primer color
      if (gr) { const lg = lum(gr[0]); if (lg !== null) return lg; }
    }
    return lum(getComputedStyle(document.body).backgroundColor) ?? 1;
  }
  let raf = 0;
  function tone() { raf = 0; const y = bar.getBoundingClientRect().bottom - 20; bar.classList.toggle('on-light', bgUnder(innerWidth / 2, y) > 0.55); }
  addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tone); }, { passive: true });
  addEventListener('resize', tone); tone();

  // ---- se esconde al bajar y vuelve apenas subís (solo si la barra tiene data-autoocultar) ----
  if (bar.hasAttribute('data-autoocultar')) {
    let ultimoY = scrollY, pend = 0;
    const revisar = () => {
      pend = 0;
      const y = scrollY, d = y - ultimoY;
      const ocupada = bar.matches(':focus-within') || document.querySelector('.ck.on,.menu.on,.menu.open');
      if (y < 90 || ocupada) bar.classList.remove('oculta');          // arriba de todo (o usándola): siempre visible
      else if (d > 6) bar.classList.add('oculta');                      // bajando: se va para no molestar
      else if (d < -6) bar.classList.remove('oculta');                  // subiendo un poco: vuelve
      if (Math.abs(d) > 6 || y < 90) ultimoY = y;
    };
    addEventListener('scroll', () => { if (!pend) pend = requestAnimationFrame(revisar); }, { passive: true });
  }
})();
